import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 40px;
  display: flex;
  overflow: auto;
  gap: 16px;

  & span {
    min-width: 300px;
  }

  @media (max-width: 700px) {
    display: flex;
    gap: 5%;
  }
`;
